import { type FunctionComponent } from 'react';
import { FilterLooks } from '../filter-looks/filter-looks.component';

export type ShopByLookHeaderProps = {
	update: (groupName: 'room' | 'style', value: string) => void;
	styles: string[];
	rooms: string[];
};

export const ShopByLookHeader: FunctionComponent<ShopByLookHeaderProps> = ({ update, styles, rooms }) => (
	<>
		<div className="flex flex-column justify-center items-center mb5 mb6-ns" data-testid="sbl-header">
			<h1 className="f2 f1-ns ma0 mb3">
				<strong>SHOP </strong>
				<span className="font-light">by</span>
				<strong> LOOK</strong>
			</h1>
			<span className="bt bb b--theme-grey-light pv1 f4 f3-ns">Home improvement shopping made easy</span>
		</div>
		<div className="mb5 mb6-ns">
			<FilterLooks updateSelection={update} selectedStyles={styles} selectedRooms={rooms} />
		</div>
	</>
);
